module.exports = __webpack_public_path__ + "static/media/importacaoEnterprise.bcaf0ff8.jpg";